<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

var price_slabs=$('.facets__price--range ul li');

if(price_slabs.length){
  $(document).on("click",".facets__price--range ul li span",function(){
    var min=$(this).attr("min");
    var max=$(this).attr("max");

    $('price-range #Filter-Min-Price-1').val(min);
    $('price-range #Filter-Max-Price-1').val(max);
    $('price-range .filter__price--apply').trigger('click');
    
    /*var final_params=[];
    var final_url="";
    
    var current_url_parts=location.href.split("?");
    var base_url=current_url_parts[0];
    
    if(current_url_parts.length>1){
      var params=current_url_parts[1];
      var params_list=params.split("&");
      var final_params=[];
      for(var i=0;i<params_list.length;i++){
        var query=params_list[i].split("=");
        if(query[0]=="filter.v.price.gte" || query[0]=="filter.v.price.lte") continue;
        final_params.push(params_list[i]);
      }

      final_params.push("filter.v.price.gte="+min);
      final_params.push("filter.v.price.lte="+max);
      final_url=base_url+"?"+final_params.join("&");
    } else {
      final_params.push("filter.v.price.gte="+min);
      final_params.push("filter.v.price.lte="+max);
      final_url=base_url+"?"+final_params.join("&");
    }

    location.href=final_url;*/
  })
}

/*Size chart toggle*/

$(document).on("click",".size-chart-toggle-in",function(){
  $('.size-chart-in').show();
  $(this).addClass('active');
  $('.size-chart-cm').hide();
  $('.size-chart-toggle-cm').removeClass('active');
})

$(document).on("click",".size-chart-toggle-cm",function(){
  $('.size-chart-cm').show();
  $(this).addClass('active');
  $('.size-chart-in').hide();
  $('.size-chart-toggle-in').removeClass('active');
})

// Minicart dynamic message

$("body").on('DOMSubtreeModified', ".cartCount", function() {
  var cartCount=$('.cartCount').text();
  var messages=$('.minicart-dynamic-data').attr('data-content');
  messages=messages.trim().split("\n");
  var result="";
  
  for(i=0;i<messages.length;i++){
    var condition=messages[i].split("=");
    if(condition.length==2){
      var condition_parts=condition[0].split(">");
      if(condition_parts.length==1){
        if(cartCount==condition[0])
          result=condition[1].trim();
      } else if(condition_parts.length==2){
        console.log(cartCount>=condition_parts[1].trim());
        if(cartCount>=condition_parts[1].trim())
          result=condition[1].trim();
      }
    }
  }

  if(result!=""){
    $('.halo-sidebar .previewCartList').find('.minicart-dynamic-message').remove();
    $('.halo-sidebar .previewCartList').after("<div class='minicart-dynamic-message'>"+result+"</div>");
  }
});